import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/auth';
import { getRateosCompanyList } from '../services/api_rateos';

import { updateJustificationCustomCompany } from '../services/api_justifications';
import Swal from 'sweetalert2';
import Fetching from './fetching';


  

const EditJustificationForm = ({ onCancel, justification, onUpdateJustification }) => {
    const { token } = useContext(AuthContext);
    const [formData, setFormData] = useState({id: justification.id, code: justification.code, description: justification.description, strategy: justification.strategy, rateo: justification.rateo?.id, has_hours: justification.has_hours});
    const [rateiCompany, setRateiCompany] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    
    const initialFormData = {
        id: justification.id,
        code: justification.code,
        description: justification.description,
        strategy: justification.strategy,
        rateo: justification.rateo ? justification.rateo.id : null,
        has_hours: justification.has_hours,
    };
    
    const handleCancel = () => {
        setFormData(initialFormData); 
        onCancel();
    };
    
    useEffect(() => {
        const fetchRateiCompany = async () => {
            setIsLoading(true);
            setError(null);
        
            try {
                const rateiCompanyData = await getRateosCompanyList(token);
                setRateiCompany(rateiCompanyData);
            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchRateiCompany();
    }, [token]);
    
    const handleUpdateJustificationCustom = async () => {
        try {
            if (formData.id === undefined) {
                throw new Error('ID del giustificativo non valido');
            }

            setIsSaving(true);

            await updateJustificationCustomCompany(token, formData.id, formData);
        
            onUpdateJustification(
                formData.id,
                {
                    ...formData,
                    rateo: rateiCompany.find(rc => rc.id === formData.rateo),
                }
            );
      
            Swal.fire({
                position: "center",
                title: "Giustificativo modificato con successo!",
                icon: "success",
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
          console.error('Errore durante la modifica del giustificativo:', error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.response?.data?.code?.join(', ') || "Errore nel salvataggio",
            });
        } finally {
            setIsSaving(false);
        }
    };
    
    
    if(isLoading)
        return <Fetching />;
    if (error) return <div>Error: {error.message}</div>;
    
    return (
        <>
        <form
            className="grid md:grid-cols-2 sm:grid-cols-1 gap-7 mt-4 w-full"
            onSubmit={(e) => {
                e.preventDefault();
                }}
        >
            <div>
                <div className='flex justify-between'>
                    <label htmlFor="code" className="block text-sm font-medium text-gray-900">Codice *</label>
                    <label htmlFor="code" className="block text-sm font-medium text-gray-900">Formato: max 3 caratteri</label>
                </div>
                <input
                    type="text"
                    id="code"
                    name="code"
                    value={formData.code}
                    onChange={(e) => setFormData({ ...formData, code: e.target.value })}
                    maxLength={3}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm placeholder:text-gray-400 placeholder:text-sm focus:border-indigo-600 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    placeholder="Esempio: A12"
                    required
                />
            </div>
            <div>
                <label htmlFor="description" className="block text-sm font-medium text-gray-900">Descrizione *</label>
                <input
                    type="text"
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm placeholder:text-gray-400 placeholder:text-sm focus:border-indigo-600 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    placeholder="Inserisci descrizione"
                    required
                />
            </div>

            <div>
                <label htmlFor="strategy" className="block text-sm font-medium text-gray-900">Strategia *</label>
                <select
                    id="strategy"
                    name="strategy"
                    value={formData.strategy}
                    onChange={(e) => setFormData({ ...formData, strategy: e.target.value })}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-600 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    required
                >
                    <option value=''>Nessuna azione</option>
                    <option value="increase">Aumenta</option>
                    <option value="decrease">Riduce</option>
                </select>
            </div>

            {formData.strategy !== '' && (
                <div>
                    <label htmlFor="rateo" className="block text-sm font-medium text-gray-900">Rateo</label>
                    {/* <select
                        id="rateo"
                        name="rateo"
                        value={formData.rateo !== null ? formData.rateo : ''}
                        onChange={(e) => setFormData({ ...formData, rateo: e.target.value !== '' ? parseInt(e.target.value) : null })}
                        className="block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-600 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    >
                        <option value="">Seleziona un rateo</option>
                        {rateiCompany.map((rateo: any) => (
                            <option key={rateo.id} value={rateo.id}>
                                {rateo.rateo.name}
                            </option>
                        ))}
                    </select> */}
                    
                    <select
                        id="rateo"
                        name="rateo"
                        value={formData.rateo || ''}
                        onChange={(e) => {
                            const selectedRateoId = e.target.value !== '' ? parseInt(e.target.value) : null;
                            setFormData({ ...formData, rateo: selectedRateoId });
                        }}
                        className="block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-600 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    >
                        <option value="">Seleziona un rateo</option>
                        {rateiCompany.map((rateo) => (
                            <option key={rateo.id} value={rateo.id}>
                                {rateo.rateo.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            <div>
                <label htmlFor="has_hours" className="block text-sm font-medium text-gray-900">È frazionabile in ore *</label>
                <select
                    id="has_hours"
                    name="has_hours"
                    value={formData.has_hours}
                    onChange={(e) => setFormData({ ...formData, has_hours: e.target.value })}
                    className="block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-600 focus:ring focus:ring-indigo-600 focus:ring-opacity-50"
                    required
                >
                    <option value="true">Si</option>
                    <option value="false">No</option>
                </select>
            </div>
        </form>

        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-7 mt-5">
            <div className="flex justify-center md:justify-end">
                <button
                    type="button"
                    className={`border border-indigo-400 flex items-center rounded-md px-5 py-2 text-center text-sm font-semibold text-white shadow-sm focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 w-24 justify-center mr-3 bg-indigo-600  ${
                        isSaving ? 'bg-gray-400 cursor-not-allowed text-gray-400' : 'bg-gray-400 hover:bg-indigo-400 hover:text-white'
                    }`}
                    onClick={handleUpdateJustificationCustom}
                    disabled={isSaving}
                >
                    {isSaving ? 'Salvataggio...' : 'Salva'}
                </button>
            </div>
            <div className="flex justify-center md:justify-start">
                <button
                    type="button"
                    onClick={handleCancel}
                    className="border border-gray-400 block rounded-md bg-grey-400 px-5 py-2 mr-2 text-center text-sm font-semibold text-gray-800 shadow-sm hover:bg-grey-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 hover:bg-gray-400 hover:text-white w-24 justify-center"
                >
                    Annulla
                </button>
            </div>
        </div>
        </>
    );
};

export default EditJustificationForm;
